import React from "react"
import { slideInDownAnimate } from "utils/animation"
import { useStaticQuery, graphql, Link } from "gatsby"
import HeroHeader from "./heroHeader"

const HeroText = ({ mobile }) => {
  const data = useStaticQuery(graphql`
    query {
      wpContentSettings(id: { eq: "cG9zdDoyMQ==" }) {
        id
        home {
          homeH1
          homeH2
        }
      }
    }
  `)

  const headTitle = data.wpContentSettings.home.homeH1
  const slogan = data.wpContentSettings.home.homeH2

  let textColor = ""
  let btnSize = ""
  mobile ? (textColor = "dark") : (textColor = "white")
  mobile ? (btnSize = "btn-sm") : (btnSize = "btn-md")

  return (
    <div
      className="col-lg-8 mx-auto my-auto text-center"
      style={{ zIndex: 1000 }}
    >
      <h2
        className={`fs-26 text-uppercase ls-xl mb-4 text-${textColor}`}
        style={slideInDownAnimate("600ms")}
      >
        {slogan}
      </h2>

      <HeroHeader title={headTitle} textColor={textColor} />

      <div className="logo-cta-wrap">
        <div className="d-flex justify-content-center mb-5 mb-md-0">
          <span style={slideInDownAnimate("1200ms")}>
            <Link
              to="/projects"
              className={`btn ${btnSize} btn-primary rounded-pill me-2`}
            >
              Explore Now
            </Link>
          </span>

          <span style={slideInDownAnimate("1500ms")}>
            <Link
              to="/contact"
              className={`btn ${btnSize} btn-outline-primary bg-white rounded-pill`}
            >
              Contact Us
            </Link>
          </span>
        </div>
      </div>
    </div>
  )
}

export default HeroText
